import { createContext } from "react"

interface ScrollRestorationContextProps {
	register: (pathname: string) => void
	restore: () => void
	save: (pathname: string, scrollY: number) => void
}

const initialScrollRestorationContext: ScrollRestorationContextProps = {
	register: () => {
		throw new Error("Called register before ScrollRestorationContext was initialized")
	},
	restore: () => {
		throw new Error("Called restore before ScrollRestorationContext was initialized")
	},
	save: () => {
		throw new Error("Called save before ScrollRestorationContext was initialized")
	},
}

export const ScrollRestorationContext = createContext<ScrollRestorationContextProps>(initialScrollRestorationContext)
